export default {"src":"/org/_next/static/media/arrow-left.6974fcd1.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};